import React from 'react';
import { FaBus, FaRoute, FaInfoCircle, FaLocationArrow } from 'react-icons/fa';

function FloatingNav({ activeTab, onTabChange, onNearbyStopsClick, nearbyStopsLoading = false, nearbyStopsActive = false }) {
  const tabs = [
    { id: 'linhas', label: 'Linhas', icon: <FaBus /> },
    { id: 'rotas', label: 'Rotas', icon: <FaRoute /> },
    { id: 'info', label: 'Info', icon: <FaInfoCircle /> }
  ];

  return (
    <div className="floating-nav">
      {tabs.map(tab => (
        <button
          key={tab.id}
          className={`floating-nav-btn ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => onTabChange(tab.id)}
          aria-label={tab.label}
          title={tab.label}
        >
          <span className="floating-nav-icon">{tab.icon}</span>
          <span className="floating-nav-label">{tab.label}</span>
        </button>
      ))}

      <button
        className={`floating-nav-btn ${nearbyStopsActive ? 'active' : ''}`}
        onClick={onNearbyStopsClick}
        aria-label="Paradas perto de mim"
        title={nearbyStopsLoading ? 'Buscando paradas...' : 'Paradas perto de mim'}
        disabled={nearbyStopsLoading}
      >
        <span className="floating-nav-icon"><FaLocationArrow /></span>
        <span className="floating-nav-label">Perto</span>
      </button>
    </div>
  );
}

export default FloatingNav;
